import { render, staticRenderFns } from "./BookingCancel.vue?vue&type=template&id=65ebab72&scoped=true"
import script from "./BookingCancel.vue?vue&type=script&lang=ts"
export * from "./BookingCancel.vue?vue&type=script&lang=ts"
import style0 from "./BookingCancel.vue?vue&type=style&index=0&id=65ebab72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ebab72",
  null
  
)

export default component.exports